import { SWAP_EXERCISE_LIST } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SWAP_EXERCISE_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case SWAP_EXERCISE_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case SWAP_EXERCISE_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
